import React from "react";

// import "@styles/Text.css";

const Text = (props) => {
    return <div className={`text ${props.className}`}>{props.children}</div>;
};
export default Text;
